import {
  ContentActionBar,
  ContentMain,
  ContentMui,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
} from './Content';
import { Header } from './Header';
import { Root } from './Root';
import { FiltersProvider, ResourceGuard, Wrapper } from './Wrapper';

export const PageMui = {
  Root,
  Header,
  ResourceGuard,
  Content: ContentMui,
  ContentActionBar,
  ContentMain,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
  Wrapper,
  FiltersProvider,
};
